import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from '../../../../User/Avatar';
import { CommentContext } from '../../../CommentContext';
import CommentFooter from '../../../lego/CommentFooter';
import ReplyCommentBox, {
  ReplyCommentBoxProps,
} from '../../../lego/ReplyCommentBox';
import ReadContentBlock from '../../../lego/ReadContentBlock';
import RootLayout from './RootLayout';
import s from './ReadView.scss';

export interface Props
  extends Partial<
    Pick<ReplyCommentBoxProps, 'canPostComment' | 'nc' | 'onReplyPosted'>
  > {
  /** Completely removes the footer. No edit controls, no reply button. Nothing. */
  includeFooter?: boolean;
}

/**
 * The read view for our standard comment preset.
 */
const ReadView: React.FC<Props> = ({
  canPostComment,
  nc,
  includeFooter = true,
  onReplyPosted,
}) => {
  const isMobile = useContext(MobileContext);
  const { comment, isReplying } = useContext(CommentContext);
  const { user } = comment;
  const canReply = !comment.isHidden && !comment.isSpam;

  return (
    <RootLayout
      prefix={
        user && <UserAvatar user={user} size={isMobile ? 24 : 32} withTooltip />
      }
      contentBlocks={[
        <ReadContentBlock
          key="main-content"
          canPostComment={canPostComment}
        />,
        includeFooter && (
          <CommentFooter
            key="footer"
            className={s['footer']}
            canPostComment={canPostComment}
          />
        ),
        isReplying && canReply && (
          <ReplyCommentBox
            key="reply"
            nc={nc}
            className={s['reply-block']}
            onReplyPosted={onReplyPosted}
            canPostComment={canPostComment}
          />
        ),
      ]}
    />
  );
};
ReadView.displayName = 'ReadView';

export default ReadView;
